<div [formGroup]="formGroup">
    <div fxLayout="row wrap" fxLayoutGap="10px">
        <dff-form-control fxFlex [formControl]="formGroup.get('statusId')"></dff-form-control>
    </div>
    <div fxLayout="row wrap" fxLayout.xs="column" fxLayoutGap="10px" fxLayoutGap.xs="0">
        <dff-form-control fxFlex [formControl]="formGroup.get('opfoelgDato')"></dff-form-control>
        <dff-form-control fxFlex [formControl]="formGroup.get('opfoelgAf')"></dff-form-control>
    </div>
    <div fxLayout="row wrap" fxLayout.xs="column" fxLayoutGap="10px" fxLayoutGap.xs="0">
        <dff-form-control fxFlex [formControl]="formGroup.get('udfoertDato')"></dff-form-control>
        <dff-form-control fxFlex [formControl]="formGroup.get('udfoertAf')"></dff-form-control>
    </div>
</div>